import { Injectable } from "@angular/core";
import type { Resolve } from "@angular/router";
import { AppSharedFacade } from '@medsurf/flat-facades';

@Injectable({
  providedIn: "root"
})
export class MetadataSharedResolver implements Resolve<void> {
  constructor(public appSharedFacade: AppSharedFacade) {
  }

  resolve() {
    return this.appSharedFacade.requestMetadata();
  }
}